import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoGarantiaTipoRespaldo } from '../_models/requisito-garantia-tipo-respaldo';

@Injectable({
  providedIn: 'root'
})
export class RequisitoGarantiaTipoRespaldoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasTiposRespaldos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo ) );
  }

  listadoPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id + '/enabled').pipe( map( res => res as RequisitoGarantiaTipoRespaldo[] ) );
  }

  crear( regCrear: RequisitoGarantiaTipoRespaldo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo ) );
  }

  bulk( regCrear: RequisitoGarantiaTipoRespaldo[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo[] ) );
  }

  actualizar( regActualizar: RequisitoGarantiaTipoRespaldo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as RequisitoGarantiaTipoRespaldo ) );
  }
}
